import { ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';

import { LegalDocumentPage } from './legal-document';
import {
  PRIVACY_POLICY_EFFECTIVE_DATE_LABEL,
  PRIVACY_POLICY_OWNER_EMAIL,
  PRIVACY_POLICY_VERSION,
  privacyPolicySections,
} from './privacy-policy-content';

export function PrivacyPolicyPage() {
  return (
    <LegalDocumentPage
      title="Política de Privacidade"
      icon={ShieldCheck}
      asideSummary="Explica que dados a BelaHora recolhe no site e na aplicação, com que finalidade os trata e que direitos assistem ao Utilizador."
      meta={[
        { label: 'Versão', value: PRIVACY_POLICY_VERSION },
        {
          label: 'Entrada em vigor',
          value: PRIVACY_POLICY_EFFECTIVE_DATE_LABEL,
        },
        { label: 'Contacto', value: PRIVACY_POLICY_OWNER_EMAIL },
      ]}
      intro={
        <>
          Esta política aplica-se ao site e à aplicação BelaHora, operados por{' '}
          <span className="font-semibold text-white">Carlos Silveira</span>.
          Quando um salão nosso cliente trata dados dos seus próprios clientes
          através da aplicação, aplica-se o{' '}
          <Link
            to="/dpa"
            className="font-semibold text-white underline underline-offset-4"
          >
            Acordo de Tratamento de Dados
          </Link>
          .
        </>
      }
      sections={privacyPolicySections}
    />
  );
}
